import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";

const ShopContext = createContext(null);
const KEY = "lostdc:cart";

export function ShopProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = useCallback((product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.slug === product.slug);
      if (found) return prev.map((i) => i.slug === product.slug ? { ...i, qty: i.qty + qty } : i);
      return [...prev, {
        slug: product.slug, name: product.name, price_inr: product.price_inr,
        dc_price: product.dc_price, image: (product.images || [])[0] || null,
        disable_dc_coin: !!product.disable_dc_coin, qty,
      }];
    });
  }, []);

  const setQty = useCallback((slug, qty) => {
    setItems((prev) => qty <= 0 ? prev.filter((i) => i.slug !== slug) : prev.map((i) => i.slug === slug ? { ...i, qty } : i));
  }, []);

  const remove = useCallback((slug) => setItems((prev) => prev.filter((i) => i.slug !== slug)), []);
  const clear = useCallback(() => setItems([]), []);

  const count = useMemo(() => items.reduce((s, i) => s + i.qty, 0), [items]);
  const subtotal = useMemo(() => items.reduce((s, i) => s + i.price_inr * i.qty, 0), [items]);

  const value = { items, add, setQty, remove, clear, count, subtotal };
  return <ShopContext.Provider value={value}>{children}</ShopContext.Provider>;
}

export function useShop() {
  const ctx = useContext(ShopContext);
  if (!ctx) throw new Error("useShop must be used within ShopProvider");
  return ctx;
}
